export enum WidgetAttribute {
    API_JSON = 'API_JSON',
    DESCRIPTION = 'DESCRIPTION',
    MORE_INFO = 'MORE_INFO',
    AUTOMATION = 'AUTOMATION',
    LINKING_JSON = 'LINKING_JSON',
    DUMMY_DATA = 'DUMMY_DATA'
}
